const getNotificationsData = () => (state) => state.notifications.notifications;
const getUnreadNotificationsData = () => (state) =>
  state.notifications.unreadNotifications;

export { getNotificationsData, getUnreadNotificationsData };
